  /* ===== BAP:JS START ===== */
(function () {
  if (customElements.get('ba-compare')) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  class BaCompare extends HTMLElement {
    connectedCallback() {
      this.handle = this.querySelector('.bap__handle');
      this.start = parseFloat(this.dataset.start) || 50;
      this.set(this.start);
      this._down = this.onDown.bind(this);
      this._move = this.onMove.bind(this);
      this._up = this.onUp.bind(this);
      this._hover = this.onHover.bind(this);
      this.addEventListener('pointerdown', this._down);
      this.handle.addEventListener('keydown', this.onKey.bind(this));
      if (this.dataset.hover === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.addEventListener('pointermove', this._hover);
      }
      if (this.dataset.intro === 'true' && !reduced && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { this.io.disconnect(); this.intro(); }
        }.bind(this), { threshold: 0.6 });
        this.io.observe(this);
      }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); this.stopAnim(); }

    set(p) {
      p = Math.max(0, Math.min(100, p));
      this.pos = p;
      this.style.setProperty('--pos', p + '%');
      if (this.handle) {
        this.handle.setAttribute('aria-valuenow', Math.round(p));
        this.handle.setAttribute('aria-valuetext', Math.round(p) + '%');
      }
      this.toggleAttribute('data-hide-before', p < 14);
      this.toggleAttribute('data-hide-after', p > 86);
    }
    pct(e) { var r = this.getBoundingClientRect(); return ((e.clientX - r.left) / r.width) * 100; }
    touched() { this.stopAnim(); this.classList.add('is-touched'); }

    onDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      this.touched();
      this.pointerType = e.pointerType;
      this.startX = e.clientX;
      this.moved = false;
      this.dragging = true;
      this.classList.add('is-dragging');
      try { this.setPointerCapture(e.pointerId); } catch (err) {}
      // En táctil no saltamos al tocar: así el usuario puede hacer scroll sin mover el slider
      if (e.pointerType !== 'touch') this.set(this.pct(e));
      this.addEventListener('pointermove', this._move);
      this.addEventListener('pointerup', this._up);
      this.addEventListener('pointercancel', this._up);
    }
    onMove(e) {
      if (!this.dragging) return;
      if (Math.abs(e.clientX - this.startX) > 3) this.moved = true;
      this.set(this.pct(e));
    }
    onUp(e) {
      if (e.type === 'pointerup' && this.pointerType === 'touch' && !this.moved) this.set(this.pct(e));
      this.dragging = false;
      this.classList.remove('is-dragging');
      this.removeEventListener('pointermove', this._move);
      this.removeEventListener('pointerup', this._up);
      this.removeEventListener('pointercancel', this._up);
    }
    onHover(e) {
      if (this.dragging || e.pointerType !== 'mouse') return;
      this.touched();
      this.set(this.pct(e));
    }
    onKey(e) {
      var step = e.shiftKey ? 10 : 2, p = this.pos;
      switch (e.key) {
        case 'ArrowLeft': case 'ArrowDown': p -= step; break;
        case 'ArrowRight': case 'ArrowUp': p += step; break;
        case 'PageDown': p -= 10; break;
        case 'PageUp': p += 10; break;
        case 'Home': p = 0; break;
        case 'End': p = 100; break;
        default: return;
      }
      e.preventDefault(); this.touched(); this.set(p);
    }

    tween(to, dur) {
      var from = this.pos, t0 = performance.now(), self = this;
      return new Promise(function (resolve) {
        var tick = function (now) {
          if (self.cancelled) return resolve(false);
          var t = Math.min(1, (now - t0) / dur);
          self.set(from + (to - from) * ease(t));
          if (t < 1) self.raf = requestAnimationFrame(tick); else resolve(true);
        };
        self.raf = requestAnimationFrame(tick);
      });
    }
    stopAnim() { this.cancelled = true; if (this.raf) cancelAnimationFrame(this.raf); }
    async intro() {
      if (this.classList.contains('is-touched')) return;
      this.cancelled = false;
      var s = this.start, amp = Math.min(22, s - 5, 95 - s);
      if (!(await this.tween(s + amp, 650))) return;
      if (!(await this.tween(s - amp, 900))) return;
      await this.tween(s, 650);
    }
  }
  customElements.define('ba-compare', BaCompare);

  class BaTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('.bap__panel'));
      var self = this;
      this.tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { self.activate(i, false); });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % self.tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + self.tabs.length) % self.tabs.length;
          if (n !== null) { e.preventDefault(); self.activate(n, true); }
        });
      });
      this._select = function (e) {
        var idx = self.panels.findIndex(function (p) { return p.dataset.blockId === e.detail.blockId; });
        if (idx > -1) self.activate(idx, false);
      };
      document.addEventListener('shopify:block:select', this._select);
    }
    disconnectedCallback() { document.removeEventListener('shopify:block:select', this._select); }
    activate(i, focus) {
      this.tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        t.tabIndex = j === i ? 0 : -1;
      });
      this.panels.forEach(function (p, j) { p.hidden = j !== i; });
      if (focus && this.tabs[i]) this.tabs[i].focus();
      var cmp = this.panels[i] && this.panels[i].querySelector('ba-compare');
      if (cmp && !reduced && !cmp.classList.contains('is-touched')) { cmp.stopAnim(); cmp.set(cmp.start); cmp.intro(); }
    }
  }
  customElements.define('ba-tabs', BaTabs);
})();
/* ===== BAP:JS END ===== */